import { InsightHighlight } from 'libs/end-to-end/src/insights';

export const insightHighlight = (
  overrides?: Partial<InsightHighlight>,
): InsightHighlight => {
  return {
    percentage: 90,
    type: 'lower',
    ...(overrides ?? {}),
  };
};
